module.exports = __webpack_public_path__ + "static/img/guoyao_xcx.125a54e0.png";